import { render, staticRenderFns } from "./ModalAddGroupAuth.vue?vue&type=template&id=48db206a&scoped=true&"
import script from "./ModalAddGroupAuth.vue?vue&type=script&lang=js&"
export * from "./ModalAddGroupAuth.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddGroupAuth.vue?vue&type=style&index=0&id=48db206a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db206a",
  null
  
)

export default component.exports